const ErrorMessage = ({ message }) => {
    return (
      <div className="alert alert-danger" role="alert">
        <h3>Error</h3>
        <p>{message}</p>
      </div>
    );
  };

export default ErrorMessage;